"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { HiRefresh, HiHome, HiExclamation } from "react-icons/hi";
import Link from "next/link";
import { useLanguage } from "@/lib/i18n";
import ErrorLayout from "@/components/layout/ErrorLayout";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { language } = useLanguage();

  useEffect(() => {
    console.error("Error occurred:", error);
  }, [error]);

  const content = language === "id" ? {
    tagline: "Kesalahan Sistem",
    title: "Terjadi Kesalahan",
    description: "Mohon maaf, kami mengalami kendala teknis. Silakan coba muat ulang halaman.",
    tryAgain: "Coba Lagi",
    backHome: "Ke Beranda",
  } : {
    tagline: "System Error",
    title: "Something Went Wrong",
    description: "We apologize for the inconvenience. Please try reloading the page.",
    tryAgain: "Try Again",
    backHome: "Go Home",
  };

  return (
    <ErrorLayout
      icon={HiExclamation}
      tagline={content.tagline}
      title={content.title}
      description={content.description}
      debugInfo={process.env.NODE_ENV === "development" ? error.message : undefined}
      actions={
        <>
          <Button
            onClick={() => reset()}
            variant="outline"
            className="w-full md:w-auto border-white/20 text-white bg-transparent hover:bg-white hover:text-brand-charcoal px-8 py-6 rounded-none uppercase text-xs font-bold tracking-[0.2em] transition-all"
          >
            <HiRefresh size={16} className="mr-2" /> {content.tryAgain}
          </Button>

          <Link href="/">
            <Button className="w-full md:w-auto bg-white text-brand-charcoal hover:bg-brand-gold hover:text-white px-8 py-6 rounded-none uppercase text-xs font-bold tracking-[0.2em] transition-all">
              <HiHome size={16} className="mr-2" /> {content.backHome}
            </Button>
          </Link>
        </>
      }
    />
  );
}
